import { graphql, useStaticQuery } from 'gatsby'

const useUiTextQuery = (slug, key) => {
  const data = useStaticQuery(graphql`
    {
      allContentfulUiText {
        edges {
          node {
            slug
            values {
              internal {
                content
              }
            }
            images {
              description
              gatsbyImageData(
                aspectRatio: 1
                quality: 90
                layout: FULL_WIDTH
                width: 500
              )
              id
            }
          }
        }
      }
    }
  `)

  const node = data.allContentfulUiText.edges.find(
    (edge) => edge.node.slug === slug
  )?.node

  return node?.[key] || JSON.parse(node.values.internal.content)[key]
}

export default useUiTextQuery
